import { AxiosInstance } from "axios";

/**
 * Google Drive's settings are four switches; nothing needs fetching to choose them, so
 * there are no calls here yet. It is registered all the same so every source answers
 * the settings API registry the same way (see `SourceRegistryParity.test.ts`), and so
 * a future lookup (say, listing shared drives) has a home.
 */
export class GoogleDriveSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  /** The HTTP client calls will use; exposed so the class is not an empty shell to the compiler. */
  get httpClient(): AxiosInstance {
    return this.client;
  }
}
